export const ERRORS_SET = 'ERRORS_SET';
export const ERRORS_RESET = 'ERRORS_RESET';

export function setError(errorMessage){
    return {
        type: ERRORS_SET,
        payload: {
            message: errorMessage,
        }
    }
}

export function resetErrors(){
    return {
        type: ERRORS_RESET,
    }
}


// WEBPACK FOOTER //
// ./src/errors/actions.js